import { Component, inject, OnInit } from '@angular/core';
import { DestroyableComponent } from '@models/destroyable.component';
import { ErrorNotificationService } from '@shared/error-notification/error-notification.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { takeUntil } from 'rxjs/operators';
import { ContextService, ScreenService } from '../../core/services/';
import { MeetingsFormService } from '../meetings-form.service';

/**
 * @see MeetingsAllComponent
 * @see MeetingsMyComponent
 * @see MeetingsFavoritesComponent
 */

@Component({
  selector: 'app-meetings-page',
  templateUrl: './meetings-page.component.html',
  styleUrls: ['./meetings-page.component.scss'],
})
export class MeetingsPageComponent extends DestroyableComponent implements OnInit {
  errorNotificationService = inject(ErrorNotificationService);
  private meetingsForm = inject(MeetingsFormService);
  private screenService = inject(ScreenService);
  private contextService = inject(ContextService);
  deviceService = inject(DeviceDetectorService);

  public me$ = this.contextService.me$;
  public isWideScreen = false;
  private width = 0;

  ngOnInit() {
    this.screenService.width$.pipe(takeUntil(this.destroyed$)).subscribe({
      next: (width) => {
        this.width = width;
        this.isWideScreen = this.screenService.isWideScreen;
      },
      error: (error) => {
        this.errorNotificationService.captureError(error, 'LOAD-SOMEDATA');
        this.width = window.innerWidth;
        this.isWideScreen = false;
      },
    });

    this.isWideScreen = this.screenService.isWideScreen;
  }
}
